import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { PriorityResponse } from 'services/tenantManagementService';
import { TICKET_PRIORITY_SET, TICKET_PRIORITY_FETCHING } from './action';

export const ticketPriorityReducer = (state = new PersistItemsReducer<PriorityResponse>(), action: PersistItemsActionType<PriorityResponse> | FetchingActionType): PersistItemsReducer<PriorityResponse> => {
	switch (action.type) {
		case TICKET_PRIORITY_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case TICKET_PRIORITY_SET:
			const { items } = action as PersistItemsActionType<PriorityResponse>;

			const itemsMap: { [id: number]: PriorityResponse } = items.reduce(
                (map: { [id: number]: PriorityResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
